interface NumberInputConfig {
    min?: number;
    max?: number;
    step?: number;
    buttondown_class?: string;
    buttonup_class?: string;
    verticalbuttons?: boolean;
    verticalup?: string;
    verticaldown?: string;
    decimals?: number;
}

export class NumberInput {
    private readonly $input: JQuery;
    public onChange?: { (value: number | undefined) };
    private readonly isFloating: boolean = false;
    private config: NumberInputConfig;

    constructor($input?: JQuery, cfg?: NumberInputConfig) {
        this.$input = $input === undefined ? $('<input type="text" class="form-control" />') : $input;

        this.config = {
            min: 1,
            max: Number.MAX_SAFE_INTEGER,
            step: 1,
            buttondown_class: "btn btn-secondary",
            buttonup_class: "btn btn-secondary",
            verticalbuttons: true,
            verticalup: '<i class="la la-plus"></i>',
            verticaldown: '<i class="la la-minus"></i>',
            decimals: undefined,
        };
        this.config = { ...this.config, ...cfg };

        if (this.config.decimals !== undefined && this.config.decimals > 0) this.isFloating = true;

        this.$input.TouchSpin(this.config);
        this.$input.change(() => {
            if (this.onChange !== undefined) this.onChange(this.getValue());
        });
    }

    public getValue(): number | undefined {
        return this.$input.val().length !== 0
            ? this.isFloating
                ? parseFloat(this.$input.val())
                : parseInt(this.$input.val())
            : undefined;
    }

    public setValue(value?: number | string): NumberInput {
        if (this.isFloating && value !== undefined && typeof value == "number")
            value = (Math.round(value * 100) / 100).toFixed(this.config.decimals);

        this.$input.val(value === undefined ? "" : value);
        return this;
    }

    public setError(hasError: boolean): NumberInput {
        if (hasError) this.$input.addClass("is-invalid");
        else this.$input.removeClass("is-invalid");

        return this;
    }

    public setDisabled(isDisabled: boolean): NumberInput {
        this.$input.prop("disabled", isDisabled);

        return this;
    }

    public destroy() {
        this.$input.TouchSpin("destroy");
    }

    public renderTo($element: JQuery): NumberInput {
        this.$input.appendTo($element);
        return this;
    }
}
